import * as httpClient from "../../../util/httpClient";
export const CheckNonCreditServicesForNCDisclaimer = (serviceList: string[]) => {
    const productList = [
        "SVC-AFM", //Advanced Fraud Monitoring

    ];
    let nonCreditProductServiceType: string = "";
    let found: boolean = false;
    if (serviceList) {
        serviceList?.forEach((p) => {
            if (p != null && p.trim().length > 0 && p !== "--") {
                if (!found) {
                    found = productList.find((element) => element === p) != null;
                    if (found) {
                        nonCreditProductServiceType = "NONCREDIT";
                    }
                }
            }
        });

    }
    return nonCreditProductServiceType;


};
